import 'intersection-observer';
import debounce from 'lodash.debounce';

import { dateParser } from './utils/d3-utils';
import { loadJsonScript } from './utils/load-json-script';
import { boot as bootCases } from './components/embeds/newDailyCases';
import { boot as bootDeaths } from './components/embeds/newDailyDeaths';

const data = loadJsonScript('statewide-timeseries-data').map((d) => {
  d.date = dateParser(d.date);
  return d;
});

const casesChart = bootCases(data);
const deathsChart = bootDeaths(data);

window.addEventListener('resize', debounce(casesChart, 300));
window.addEventListener('resize', debounce(deathsChart, 300));
